import { Longhand } from "../longhand.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-variant-caps}
 * @internal
 */
export default Longhand.fromKeywords({ inherits: true }, "normal", "small-caps", "all-small-caps", "petite-caps", "all-petite-caps", "unicase", "titling-caps");
//# sourceMappingURL=font-variant-caps.js.map